"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
const faqs = [{
  question: "תוך כמה זמן ניתן להציב מטפל סיעודי בחיפה?",
  answer: <>
        אנו מבינים את הדחיפות במצבים סיעודיים, ולכן אנו מתחייבים למענה מהיר במיוחד באזור חיפה והקריות. ברוב המקרים, אנו מסוגלים להציב{" "}
        <Link to="/NursingCareProviderInHaifaWithinHoursPage" className="text-primary font-bold hover:underline">מטפל סיעודי בחיפה</Link>{" "}
        מקצועי בבית המטופל או בבית החולים תוך פחות מ-5 שעות מרגע הפנייה הראשונית, כדי להבטיח רצף טיפולי וביטחון מלא למשפחה.
      </>
}, {
  question: "מהן העלויות הממוצעות לשירותי סיעוד באזור הצפון?",
  answer: <>
        התמחור בחיפה והצפון מושפע מהיקף השעות הנדרש (שעתי או 24/7) וממורכבות הטיפול. ניתן לקרוא עוד על{" "}
        <Link to="/ProfessionalBlogPage" className="text-primary font-bold hover:underline">כמה עולה מטפל סיעודי</Link>{" "}
        בבלוג שלנו. אנו מציעים מחירים תחרותיים ושקופים, תוך התחשבות בזכאויות של המוסד לביטוח לאומי. פגישת הייעוץ הראשונית והערכת הצרכים בביתכם בחיפה ניתנות ללא עלות.
      </>
}, {
  question: "אילו הכשרות עוברים המטפלים שלכם?",
  answer: <>
        כל המטפלים והמטפלות בצוות שלנו עוברים סינון קפדני הכולל בדיקת רקע והכשרות מקצועיות. אנו מספקים{" "}
        <Link to="/CaregiverServicePagesPage" className="text-primary font-bold hover:underline">שירותי סיעוד בבית</Link>{" "}
        ברמה הגבוהה ביותר, תוך דגש על יחסי אנוש מעולים והבנה עמוקה של צרכי המטופל ומשפחתו.
      </>
}, {
  question: "מה קורה במקרה של מצב חירום רפואי?",
  answer: <>
        יש לנו פרוטוקול חירום ברור ומסודר. כל מטפל בקיא בנהלי הדיווח למד"א ולבתי החולים בחיפה. השירות שלנו כולל גם{" "}
        <Link to="/NursingCareNowPage" className="text-primary font-bold hover:underline">השגחה בבית חולים</Link>{" "}
        במידת הצורך, והמוקד שלנו זמין 24/7 למתן תמיכה והנחיות למטפל ולמשפחה בכל רגע נתון.
      </>
}, {
  question: "באילו שכונות בחיפה אתם מספקים שירות?",
  answer: <>
        אנו מספקים כיסוי מלא לכל שכונות חיפה: מהכרמל ודניה ועד לקריות. בנוסף לחיפה, אנו פעילים בערים נוספות ומציעים{" "}
        <Link to="/NursingCaregiverInTelAvivWithinFiveHoursPage" className="text-primary font-bold hover:underline">מטפל סיעודי בתל אביב</Link>,{" "}
        <Link to="/NursingCareProviderInJerusalemWithinFiveHoursPage" className="text-primary font-bold hover:underline">בירושלים</Link>{" "}
        וכן{" "}
        <Link to="/NursingCareInRamatGanWithinHoursPage" className="text-primary font-bold hover:underline">מטפל סיעודי ברמת גן</Link>{" "}
        בזמינות מיידית.
      </>
}, {
  question: "האם אתם עובדים עם חברות הביטוח וקופות החולים?",
  answer: <>
        בהחלט. אנו משתפים פעולה עם מרבית חברות הביטוח הפרטיות וקופות החולים. למידע נוסף על מימוש זכויות, מומלץ לבקר ב-
        <Link to="/ProfessionalBlogPage" className="text-primary font-bold hover:underline">בלוג המקצועי</Link>{" "}
        שלנו. הצוות המשרדי שלנו מסייע למשפחות בחיפה בבירוקרטיה הנדרשת כדי להקל עליכם את נטל התשלום.
      </>
}, {
  question: "איך מתבצע תהליך ההתאמה בין המטפל למטופל?",
  answer: <>
        התאמה נכונה היא המפתח להצלחה. אנו בוחנים את הצרכים הפיזיים, השפה והרקע התרבותי. למידע על מגוון השירותים שלנו, עברו לדף{" "}
        <Link to="/ServicesCitiesArticlesPage" className="text-primary font-bold hover:underline">שירותים וערים</Link>.{" "}
        בחיפה אנו דואגים להציב מטפל דובר השפה המבוקשת ליצירת תקשורת מיטבית ונוחות מקסימלית.
      </>
}];
export default function FaqAccordion() {
  return <section data-section-id="256918" id="שאלות-נפוצות-מטפל-סיעודי-בחיפה" className="bg-background text-foreground py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="mb-10 text-center">
          <h2 className="font-default text-3xl font-bold text-primary md:text-4xl">
            שאלות נפוצות - שירותי סיעוד בחיפה
          </h2>
        </div>

        <div className="rounded-lg border border-border bg-card p-4 shadow-md md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
                <AccordionTrigger className="text-right font-default text-lg font-bold text-foreground hover:text-secondary hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-default text-base leading-relaxed text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}